import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["instalmentField"]

  toggleInstalment(event) {
    const value = event.target.value || ""
    if (value.includes("Parcelado")) {
      this.instalmentFieldTarget.style.display = ""
    } else {
      this.instalmentFieldTarget.style.display = "none"
    }
  }
}
